<template>
<div class="my-express">
  <!--表格头部搜索开始-->
  <div class="search-bar">
		<em>发货日期：</em>
     <el-date-picker
      class='date'
      v-model="startDate"
      align="right"
      type="date"
      placeholder="选择开始日期"
      value-format="yyyy-MM-dd"
      :picker-options="startpickerOptions">
    </el-date-picker>
    至
    <el-date-picker
      class='date'
      v-model="endDate"
      align="right"
      type="date"
      placeholder="选择结束日期"
      value-format="yyyy-MM-dd"
      :picker-options="endpickerOptions">
    </el-date-picker>
   <el-select v-model="track_status" clearable placeholder="物流状态" style="width: 110px; margin-right: 0px; margin-left:10px;">
      <el-option key='unsign' label="未签收" value="unsign"></el-option>
      <el-option key='sign' label="已签收" value="sign"></el-option>
      <el-option key='notSupport' label="不支持" value="notsupport"></el-option>
   </el-select>
    <el-input 
      v-model="keywords" 
      placeholder="运单号、收件人的姓名、电话快速查找" 
      prefix-icon="el-icon-search" 
      :clearable="true" 
      @keyup.enter.native="searchInput"
      style="width: 280px; margin-right: 10px; margin-left:10px;">
    </el-input>
    <el-button type="primary" @click.native="searchInput">查询</el-button>
    <el-button type="success" @click.native="ClearSearchInput">清空</el-button>
    <!-- <el-button type="success">导出</el-button> -->
  </div>
  <!--表格头部搜索结束-->
  <div class="order-list">
    <div class="table_total_cost">总记录：<span class="total_num">{{total}}</span> 条，费用总计：<span class="total_num">{{waybillTotalMoney}}</span> 元，已付：<span class="total_num">{{receiveTotalMoney}}</span> 元，未付：<span>{{unreceiptTotalMoney}}</span> 元</div>
    
    <el-table border  v-loading="loading" :data="list" show-summary :summary-method="getSummaries" empty-text="暂无数据" style="width: 100%;">
      <el-table-column fixed type="index" label="序号" width="50"></el-table-column>
      <el-table-column fixed prop="waybill_type" label="运单类型" align="left" width="80"></el-table-column>
      <el-table-column fixed prop="waybill_number" label="运单号" align="left" width="120">
        <template slot-scope="scope">
            <div slot="reference" style="color:#409EFF;text-decoration:underline;cursor:pointer;" @click="handleDetail(scope.row)">{{scope.row.waybill_number}}</div>
        </template>
      </el-table-column>
      <el-table-column fixed prop="waybill_transfer_number" label="转运单号" width="120">
          <template slot-scope="scope">
            <el-popover trigger="hover" @show="transfer_station_info(scope.row.waybill_id)" placement="top">
              <div class="transfer_info">
                <p>转运单号：{{ scope.row.waybill_transfer_number }}</p>
                <p>转运公司：{{ transfer_info.company_name }}</p>
                <p>发站：{{ transfer_info.company_startstop }}</p>
                <p>发站电话：{{ transfer_info.company_startstop_phone }}</p>
                <p>到站：{{ transfer_info.company_endstop }}</p>
                <p>到站电话：{{ transfer_info.company_endstop_phone }}</p>
              </div>
              <div slot="reference" class="name-wrapper">
                {{ scope.row.waybill_transfer_number }}
              </div>
            </el-popover>
          </template>
      </el-table-column>
      <el-table-column fixed='right' label="运单详情" width="100">
        <template slot-scope="scope">
          <div style="color:#409EFF;text-decoration:underline;cursor:pointer; float:left;margin-right:5px;" @click="handleDetail(scope.row)">详情</div>
        </template>
      </el-table-column>
      <el-table-column prop="waybill_track_status" label="轨迹状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="scope.row.waybill_track_status === '签收' ? 'danger' : 'primary'">{{ scope.row.waybill_track_status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="waybill_track_lastinfo" label="最后轨迹" width="300" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="waybill_business_type" label="业务类型" width="100"></el-table-column>
      <el-table-column prop="waybill_send_date" label="发货日期" width="95" :formatter="dateFormat"></el-table-column>
      <el-table-column prop="waybill_receipt_province" label="目的省份" :show-overflow-tooltip="true" width="100"></el-table-column>
      <el-table-column prop="waybill_send_user" label="发货人" :show-overflow-tooltip="true" width="80"></el-table-column>
      <el-table-column prop="waybill_receipt_user" label="收货人" width="80"></el-table-column>
      <el-table-column prop="waybill_goods_num" label="件数" align="center" width="80"></el-table-column>
      <el-table-column prop="waybill_goods_customer_weight" label="重量" align="center" width="80"></el-table-column>
      <el-table-column prop="waybill_goods_customer_volume" label="体积" align="center" width="80"></el-table-column>
      <el-table-column prop="waybill_total_money" label="费用总计" width="80"></el-table-column>
      <el-table-column prop="waybill_receive_money" label="已付" width="80"></el-table-column>
      <el-table-column prop="waybill_unreceipt_money" label="未付" width="80"></el-table-column>
      <el-table-column prop="waybill_payment_method" label="结算方式" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.waybill_payment_method === '现付' ? 'primary' : 'danger'">{{ scope.row.waybill_payment_method }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="waybill_freight_fee" label="运费" width="80"></el-table-column>
      <el-table-column prop="waybill_advance_fee" label="垫付运费" width="80"></el-table-column>
      <el-table-column prop="waybill_pack_fee" label="包装费" width="80"></el-table-column>
      <el-table-column prop="waybill_warehouse_fee" label="进仓费" width="80"></el-table-column>
      <el-table-column prop="waybill_warehouse_service_fee" label="进仓服务费" width="95"></el-table-column>
      <el-table-column prop="waybill_upstairs_fee" label="上楼费" width="80"></el-table-column>
      <el-table-column prop="waybill_exceed_delivery_fee" label="超派费" width="80"></el-table-column>
      <el-table-column prop="waybill_delivery_receipt_fee" label="回单费" width="80"></el-table-column>
      <el-table-column prop="waybill_delivery_fee" label="送货费" width="80"></el-table-column>
      <el-table-column prop="waybill_inventory_fee" label="清点费" width="80"></el-table-column>
      <el-table-column prop="waybill_arrange_fee" label="码放费" width="80"></el-table-column>
      <el-table-column prop="waybill_insurance_fee" label="保价费" width="80"></el-table-column>
      <el-table-column prop="waybill_other_fee" label="其它费" width="80"></el-table-column>
     
      <el-table-column prop="waybill_remark" label="备注" :show-overflow-tooltip="true" width="120"></el-table-column>
    </el-table>
  </div>
  <div class="page">
    <el-pagination background  @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total,prev, pager, next, sizes" :total="total"></el-pagination>
  </div>

  <el-drawer title="物流轨迹" :visible.sync="dialogVisible" :modal="false" direction="rtl" size="600px">
    <div style="padding:0px 20px;">
      <div class="ordertrack_info">运单号：{{dialogrow.waybill_number}} 业务类型：{{dialogrow.waybill_business_type}}</div>
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :color="activity.color"
            placement="top"
            :timestamp="activity.timestamp">
            {{activity.content}}
          </el-timeline-item>
        </el-timeline>
    </div>
  </el-drawer>
    <!--@open="getOrderImages(orderDetailInfo.order_number)"-->
  <el-drawer title="运单详情" :visible.sync="orderDetail" direction="rtl" size="750px">
    <div class="section">
      <div class="section-header">
        <div class="section-mark" style="border-left-color: rgb(70, 205, 207);"></div> 
        <div class="section-title">基本信息 </div>
      </div>
    </div>
      <flexbox :gutter="0" wrap="wrap" style="padding: 10px 8px 0;">
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">运单号</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_number}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">业务类型</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_business_type}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">发货日期</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_send_date}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">目的省份</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_receipt_province}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">转运单号</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_transfer_number}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">承运公司</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_transfer_company}}</div>
          </flexbox>
        </flexbox-item>
      </flexbox>

      <div class="section">
        <div class="section-header">
          <div class="section-mark" style="border-left-color: rgb(70, 205, 207);"></div> 
          <div class="section-title">寄件人信息</div>
        </div>
      </div>
      <flexbox :gutter="0" wrap="wrap" style="padding: 10px 8px 0;">
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">寄件人</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_send_user}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">联系电话</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_send_phone}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="12" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">详细地址</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_send_address}}</div>
          </flexbox>
        </flexbox-item>
      </flexbox>

      <div class="section">
        <div class="section-header">
          <div class="section-mark" style="border-left-color: rgb(70, 205, 207);"></div> 
          <div class="section-title">收件人信息</div>
        </div>
      </div>
      <flexbox :gutter="0" wrap="wrap" style="padding: 10px 8px 0;">
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">收件人</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_receipt_user}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">联系电话</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_receipt_phone}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="12" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">详细地址</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_receipt_address}}</div>
          </flexbox>
        </flexbox-item>
      </flexbox>

      <div class="section">
        <div class="section-header">
          <div class="section-mark" style="border-left-color: rgb(70, 205, 207);"></div> 
          <div class="section-title">货物信息</div>
        </div>
      </div>
      <flexbox :gutter="0" wrap="wrap" style="padding: 10px 8px 0;">
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">件数</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_goods_num}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">重量</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_goods_customer_weight}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">体积</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_goods_customer_volume}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">包装</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_goods_package}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">货物名称</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_goods_name}}</div>
          </flexbox>
        </flexbox-item>
      </flexbox>

      <div class="section">
        <div class="section-header">
          <div class="section-mark" style="border-left-color: rgb(70, 205, 207);"></div> 
          <div class="section-title">费用明细</div>
        </div>
      </div>
      <flexbox :gutter="0" wrap="wrap" style="padding: 10px 8px 0;">
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">运费</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_freight_fee}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">垫付运费</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_advance_fee}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">包装费</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_pack_fee}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">进仓费</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_warehouse_fee}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">进仓服务费</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_warehouse_service_fee}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">上楼费</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_upstairs_fee}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">超派费</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_exceed_delivery_fee}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">回单费</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_delivery_receipt_fee}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">送货费</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_delivery_fee}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">清点费</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_inventory_fee}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">码放费</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_arrange_fee}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">保价费</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_insurance_fee}}</div>
          </flexbox>
        </flexbox-item>
        
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">其它费</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_other_fee}}</div>
          </flexbox>
        </flexbox-item>
        <el-divider style="background-color: red;"></el-divider>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">费用总计</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_total_money}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">已付</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_receive_money}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">未付</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_unreceipt_money}}</div>
          </flexbox>
        </flexbox-item>
        <flexbox-item :span="4" class="b-cell">
          <flexbox align="stretch" class="b-cell-b">
              <div class="b-cell-name">结算方式</div>
              <div class="b-cell-value">{{orderDetailInfo.waybill_payment_method}}</div>
          </flexbox>
        </flexbox-item>
      </flexbox>

      <div class="section">
        <div class="section-header">
          <div class="section-mark" style="border-left-color: rgb(70, 205, 207);"></div> 
          <div class="section-title">运单图片</div>
        </div>
      </div>
      <el-row style="padding:15px;">
        <el-col :span="24" :gutter="4" v-for="(item,index) in orderImagesList" :key="index" >
          <el-card :body-style="{ padding: '0px' }" style="margin-top: 13px;">
            <el-image class="image" :src="item.waybill_image_url" :preview-src-list="item.waybill_image_preview">
              <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
              </div>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
             </div>
            </el-image>
            <div style="padding: 14px;">
              <span>单号：{{item.waybill_image_number}}</span>
            </div>
          </el-card>
        </el-col>
    </el-row>
    <div class="section">
        <div class="section-header">
          <div class="section-mark" style="border-left-color: rgb(70, 205, 207);"></div> 
          <div class="section-title">物流轨迹 </div>
        </div>
    </div>
    <div style="padding:0px 20px;">
      
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :color="activity.color"
            placement="top"
            :timestamp="activity.timestamp">
            {{activity.content}}
          </el-timeline-item>
        </el-timeline>
    </div>
</el-drawer>

</div>
</template>

<script>
import {orderList,transferStationInfo,orderTrackInfo,orderImages,orderInfo,orderCheck} from '@/api/Order/order'
import moment from 'moment'
export default {
  name: "order",
  components: {},
  data() {
      return {
        loading:false,   //表格数据载入效果
        dialogVisible:false, // 物流跟踪弹出框 显示状态
        dialogrow:'',    // 物流跟踪弹出框 标题
        activities: [],    // 物流跟踪信息内容
        orderDetail:false,  // 运单详细 右侧弹窗 显示状态
        orderDetailInfo:[],  // 运单信息
        orderImagesList:[],  // 运单图片信息      
        waybillTotalMoney:0,   //当前总费用
        receiveTotalMoney:0, //当前总已付费用
        unreceiptTotalMoney:0, // 当前总未付费用
        list: [],    //表格数据
        total: 0,    //表格数据总记录数
        currentPage: 1,
        pageSize: 10,
        keywords: '', // 搜索内容
        //时间控件的值
        startDate:'',
        endDate:'',
        timedata:[],
        minDate:'',
        maxDate:'',
        //搜索关键字
        keywords:'',
        customer_check: '',
        track_status:'',
        transfer_info:{},

        startpickerOptions: {
            disabledDate: (time) => {
              if (this.endDate)
              {
                let endDateVal = new Date(this.endDate);
                return time.getTime() > endDateVal;
              }
              else
              {
                  return time.getTime() > Date.now();
              }
            }
          },
          endpickerOptions: {
            disabledDate: (time) => {
                if (this.startDate)
                {
                  let endDateVal = new Date(this.startDate);
                  return time.getTime() < endDateVal - 8.64e7 || time.getTime() > Date.now();
                }
                else
                {
                    return time.getTime() > Date.now();
                }
            }
          }
        
      };
    },
    methods: {
      // 进行搜索操作
      searchInput() {
        this.$emit('on-search', this.keywords)
        this.getList()
      },
      ClearSearchInput(){
        this.startDate='';
        this.endDate='';
        this.currentPage=1;
        this.track_status='';
        this.customer_check='';
        this.keywords='';
        this.getList()
      },
      // 更改当前页数
      handleCurrentChange(val) {
        this.currentPage = val
        this.getList()
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize=val
        this.currentPage = 1
        console.log(`当前页 ${this.currentPage} 条`);
        this.getList()
      },
      handleClick(tab, event) {
        //console.log(tab, event);
      },
      //时间格式化
      dateFormat(row, column, cellValue, index){
         const daterc = row[column.property]
         if(daterc!=null)
         {
            const dateMat= new Date(daterc);
            const year = dateMat.getFullYear();
            const month = dateMat.getMonth() + 1;
            const day = dateMat.getDate();
            const hh = dateMat.getHours();
            const mm = dateMat.getMinutes();
            const ss = dateMat.getSeconds();
            const timeFormat= year + "-" + month + "-" + day;
            return timeFormat;
         }
        else
        {
            return '';
        }   
       },
      /** 获取列表数据 */
      getList() {
        this.loading = true
        var params = {
        page: this.currentPage,
        limit: this.pageSize,
        track_status:this.track_status,
        customer_check: this.customer_check,
        keywords:this.keywords
        // start_time:this.minDate,
        // end_time:this.maxDate,
        }
        if (this.keywords && this.keywords.length > 0) 
        {
          params.keywords =this.keywords
        }
        if (this.startDate && this.startDate.length > 0) 
        {
          params.start_time =this.startDate
        }
        if (this.endDate && this.endDate.length > 0) 
        {
          params.end_time =this.endDate
        }
        orderList(params)
        .then(res => {
          this.list = res.data.list
          this.total = res.data.dataCount
          this.waybillTotalMoney = res.data.waybillTotalMoney
          this.receiveTotalMoney = res.data.receiveTotalMoney
          this.unreceiptTotalMoney = res.data.unreceiptTotalMoney
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        const sumField = ['waybill_goods_num','waybill_goods_customer_weight','waybill_goods_customer_volume','waybill_freight_fee','waybill_advance_fee','waybill_pack_fee','waybill_warehouse_fee','waybill_warehouse_service_fee','waybill_upstairs_fee','waybill_exceed_delivery_fee','waybill_delivery_receipt_fee','waybill_delivery_fee','waybill_inventory_fee','waybill_arrange_fee','waybill_insurance_fee','waybill_other_fee','waybill_total_money','waybill_receive_money','waybill_unreceipt_money'];
        columns.forEach((column, index) => {
          if (index === 1) 
          {
            sums[index] = '合计：';
            return;
          }
          
          //var a = fruits.indexOf("Apple"); 
          if (sumField.indexOf(column.property)!=-1)
          {
              const values = data.map(item => Number(item[column.property]));
              if (!values.every(value => isNaN(value))) {
                sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
                if (column.property=='order_goods_num')
                {
                   sums[index]
                }
                else
                {
                    sums[index] = sums[index].toFixed(2) ;
                }
                
              } else {
                sums[index] = 'N/A';
              }
              }
          
        });

        return sums;
      },
      transfer_station_info(id){
          transferStationInfo({waybill_id:id})
                .then(res => {
                  this.transfer_info = res.data
                })
                .catch(() => {
                  this.loading = false
                })
      },
      handleDetail(row){
          this.orderDetail=true
          //this.orderDetailInfo=row
          orderInfo({waybill_id:row.waybill_id})
                .then(res => {
                  this.orderDetailInfo=res.data.waybill_info
                  this.orderImagesList=res.data.waybill_images
                  this.orderTrackInfo(row)
                })
                .catch(() => {
                  this.loading = false
                  this.orderDetail = false
                })
          
      },
      getOrderImages(order_number){
          //console.log(order_number)
          orderImages({order_number:order_number})
                .then(res => {
                  if (res.data.length>0)
                  {
                      this.orderImagesList = res.data
                  }
                  else
                  {
                      this.orderImagesList = []
                  }
                  
                })
                .catch(() => {
                  this.loading = false
                })
      },
      orderTrack(row){
          //console.log(order_number)
          orderTrackInfo({waybill_id:row.waybill_id})
                .then(res => {
                  if ( res.data)
                  {
                      this.dialogVisible=true
                      this.dialogrow=row
                      this.activities = res.data
                  }
                  else
                  {
                    
                  }
                  
                })
                .catch(() => {
                  this.loading = false
                })
      },
      orderTrackInfo(row){
          //console.log(order_number)
          orderTrackInfo({waybill_id:row.waybill_id})
                .then(res => {
                  if ( res.data)
                  {
                      this.activities = res.data
                  }
                })
                .catch(() => {
                  this.loading = false
                  this.activities = []
                })
      },
      orderCheck(order_id){
          //console.log(order_number)
          orderCheck({order_id:order_id,action:'check'})
                .then(res => {
                  if (res.data)
                  {
                      this.orderDetailInfo['order_customer_check']=1
                      this.getList ()
                  }
                })
                .catch(() => {
                  this.loading = false
                })
      },
      orderUnCheck(order_id){
          //console.log(order_number)
          orderCheck({order_id:order_id,action:'uncheck'})
                .then(res => {
                  if (res.data)
                  {
                      this.orderDetailInfo['order_customer_check']=0
                      this.getList ()
                  }
                })
                .catch(() => {
                  this.loading = false
                })
      }
    },
    mounted(){
      this.getList ()
    }
};
</script>
<style lang="scss" >
.my-express {
  width: 100%;
}
.my-express .search-bar {
	padding: 30px 25px;
  width: 100%;
  background-color: #fff;
}

.my-express .search-bar .date {
	width: 150px;
}
.my-express .search-bar .date .el-range-separator{
  padding: 0;
}

.my-express .search-bar em {
	font-style: normal;
}

.my-express .order-list{
  padding: 0px 20px 20px 20px;
  background-color: #fff;
}

.table_total_cost {
    line-height: 25px;
    font-size: 14px;
}

.table_total_cost span {
    color: #FF0000;
    font-weight: bold;
}

.table_total_cost .total_num{
  color: #409EFF;
}



.my-express .order-list .el-table .el-table__header th{
    background:#f5f6f7;font-weight: bold;color: #909399;
}

.my-express  .el-table--scrollable-x .el-table__body-wrapper{
z-index: 2;
}
// .pj-table-header{
//   background-color: #f5f6f7;
// }
.transfer_info p{
  line-height: 28px;
}
.my-express .page {
	padding: 20px 0;
	margin: 15px auto;
	text-align: center;
	background-color: #fff;
}

.my-express .info-box .barcode {
	display: block;
	width: 100%;
}

.my-express .info-box .bar {
	margin-bottom: 10px;
}

.my-express .info-box .bar p {
	font-size: 18px;
	line-height: 30px;
	text-align: center;
}

.my-express .info-box table {
	width: 100%;
	background-color: #ccc;
}

.my-express .info-box table td {
	background-color: #fff;
}

.my-express .info-box table td:first-child {
	width: 20%;
	text-align: center;
}

.my-express .info-box table td:last-child {
	width: 80%;
	padding: 15px 20px;
}

.my-express .info-box table td em,.my-express .info-box table td i {
	font-style: normal;
}

.my-express .info-box table td h3 {
	padding-bottom: 10px;
}

.my-express .info-box table td p {
	line-height: 25px;
}

.my-express .info-box table td p i {
	color: #000;
}

.cancel-box .btn {
	width: 32%;
	padding: 15px;
	margin: 0 2% 20px 0;
}

.cancel-box .btn:nth-child(3n+3) {
	margin-right: 0;
}

.cancel-box .title {
	padding: 20px 0;
	font-size: 16px;
}

.my-express .el-drawer.ltr, .el-drawer.rtl, .el-drawer__container {
    position: fixed;
    top: 75px;
    bottom: 0;
    right: 0;
    border-top-left-radius:4px;
    border-bottom-left-radius:4px;
    overflow-y: scroll;
    height: auto;
}

.my-express .order-list .el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
.my-express .el-table__body tr,
  .el-table__body td {
    padding: 0;
    height: 40px;
}


.section {
  position: relative;
  background-color: white;
  margin-top: 8px;
}
.section:first-child {
  margin-top: 0;
}

.section-mark {
  border-left-width: 3px;
  border-left-style: solid;
  height: 10px;
}

.section-header {
  display: flex;
  align-items: center;
  padding: 5px 15px;
}
.section-title {
  font-size: 14px;
  color: #333;
  font-weight: bold;
  margin-left: 8px;
  flex-shrink: 0;
}

.b-cell {
  padding: 0 10px;
  .b-cell-b {
    width: auto;
    padding: 3px;
    .b-cell-name {
      width: 70px;
      margin-right: 10px;
      font-size: 14px;
      flex-shrink: 0;
      color: #777;
    }
    .b-cell-value {
      font-size: 14px;
      color: #333;
      //white-space: pre-wrap;
      word-wrap: break-word;
      white-space:nowrap;
      overflow: hidden;
      text-overflow:ellipsis;
    }
    .b-cell-foot {
      flex-shrink: 0;
      display: block;
      width: 15px;
      height: 15px;
      margin-left: 8px;
    }
  }
}

.f-item {
  padding: 3px 0;
  height: 25px;
  .f-img {
    position: block;
    width: 15px;
    height: 15px;
    padding: 0 1px;
    margin-right: 8px;
  }
  .f-name {
    color: #666;
    font-size: 12px;
    margin-right: 10px;
  }
}

.image {
    width: 100%;
    display: block;
  }

  .el-image-viewer__wrapper {
    position: fixed;
    top: 75px;
    right: 0;
    bottom: 0;
    left: 0;
}
.el-image-viewer__close {
    color: #fff;
}

.el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 0;
    border-top: 1px dashed #f50d0d;
}
.ordertrack_info{
  font-size: 14px;
  line-height: 25px;
  height: 30px;
  margin-bottom: 20px;
}
</style>
